// removed by extract-text-webpack-plugin
module.exports = {"createAccountForm":"_416ODnyvEMVrisQxIwba"};


//////////////////
// WEBPACK FOOTER
// ./src/uis/components/Form/CreateAccountForm/CreateAccountForm.css
// module id = 1318
// module chunks = 0